import { AnagraficaSocieta } from "./anagrafica-societa";
import { AnagraficaUtente } from "./anagrafica-utente";

export class AnagraficaSocietaCompleta {
    societa: AnagraficaSocieta = new AnagraficaSocieta();
    listaTecnici: AnagraficaUtente[] = [];
    listaUtenti: AnagraficaUtente[] = [];
    listaTecniciDisponibili: AnagraficaUtente[] = [];
}